import React from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import Experience from '../components/Experience';
import Amenities from '../components/Amenities';
import Trails from '../components/Trails';
import Location from '../components/Location';
import Testimonials from '../components/Testimonials';
import Faq from '../components/Faq';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <>
      <Navbar />
      <Hero />
      <Experience />
      <Amenities />
      <Location />
      <Trails />
      <Testimonials />
      <Faq />
      <Contact />
      <Footer />
    </>
  );
};

export default Home;
